//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
import axios from 'axios';

export default {
  layout: function layout(context) {
    return global.getTheme();
  },
  data: function data() {
    return {
      support_phone: "",
      support_phone_me: "",
      whats_up_phone: "",
      geoCountryCode: "",
      support_email: "",
      reason: "",
      name: "",
      email: "",
      phone: "",
      details_description: "",
      paymentMethod: '',
      website: '',
      loggedUser: {},
      domain: '',
      domain_email: '',
      view: 'default'
    };
  },
  mounted: function mounted() {
    this.loadPhoneInput();
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  created: function created() {
    var _this = this;

    this.view = global.getTheme();
    if (process.browser) {
      this.domain = document.location.hostname.replace('.com', '').replace('www.', '');
      this.domain_email = 'info@' + this.domain + '.com';
    }
    this.support_phone = global.websiteSettings.config.support_phone;
    this.support_email = global.websiteSettings.config.support_email;
    this.whats_up_phone = global.websiteSettings.config.whats_up_phone;
    this.support_phone_me = global.websiteSettings.config.support_phone_me;
    this.geoIpLookup(function (countryCode) {
      this.geoCountryCode = countryCode;
    }.bind(this));

    global.getPaymentMethodId().then(function (value) {
      _this.paymentMethod = value;
    });
    if (process.client) {
      this.refreshLoggedUser();
    }
    this.website = this.$root.trans(global.websiteSettings.extra_info.title);
  },
  head: function head() {
    return {
      titleTemplate: this.getTitle(),
      meta: [{ hid: 'description', name: 'description', content: this.getDescription() }, { hid: 'keywords', name: 'keywords', content: this.getKeywords() }, { hid: 'og:description', name: 'og:description', content: this.getDescription() }, { hid: 'og:title', name: 'og:title', content: this.getTitle() }]
    };
  },

  methods: {
    getTitle: function getTitle() {
      return this.$root.trans('st_public.contact_us', this.$root._route.params.lang) + ' - ' + this.$root.trans(global.websiteSettings.extra_info.title);
    },
    getDescription: function getDescription() {
      return this.$root.trans('st_public.contact_us_meta_tags', { website: this.$root.trans(global.websiteSettings.extra_info.title) });
    },
    getKeywords: function getKeywords() {
      return this.$root.trans(global.websiteSettings.extra_info.title) + ', ' + this.$root.trans('st_public.contact_us', this.$root._route.params.lang);
    },
    contactus: function contactus() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.loading = true;
          var requestParams = {};
          requestParams.reason = _this2.reason;
          requestParams.email = _this2.email;
          requestParams.name = _this2.name;
          requestParams.phone = _this2.phone;
          requestParams.details_description = _this2.details_description;

          var subscriptionUrl = global.getEndPoint() + 'api/contactus';

          axios.post(subscriptionUrl, requestParams /*, {headers: {'X-Cookie': this.getAllCookies()}}*/).then(function (res) {
            if (flash) flash(_this2.$root.trans('st_public.contact_form_submitted_successfully'), 'success');

            _this2.loading = false;
            _this2.reason = "";
            _this2.name = "";
            _this2.email = "";
            _this2.phone = "";
            _this2.details_description = "";
            _this2.errors.clear();
            $("#email_us").modal("hide");
          }).catch(function (err) {
            _this2.loading = false;
            if (err.message) {
              if (flash) flash(_this2.$root.trans('st_public.' + err.message), 'error');
            }
            _this2.errors.clear();
            var errors = err.response.data.errors;
            if (errors) {
              for (var field in errors) {
                _this2.errors.add(field, errors[field].join(', '));
              }
            }
          });
        }
      });
    },
    geoIpLookup: function geoIpLookup(callback) {
      axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/common/geo-country').then(function (res) {
        var countryCode = res.data.country;
        callback(countryCode);
      });
    },
    getAllCookies: function getAllCookies() {
      if (process.client) {
        return document.cookie;
      }
      return '';
    },
    loadPhoneInput: function loadPhoneInput() {
      if (process.client) {
        require('intl-tel-input');

        $("#phone").intlTelInput({
          initialCountry: 'auto',
          geoIpLookup: this.geoIpLookup
          //, utilsScript: "/js/utils.js"
        });
        $('#phone').css('text-align', 'right');
        $('#phone').css('direction', 'ltr');
        $('.country-list li').css('direction', 'ltr');
        $('.intl-tel-input').addClass('form-control-lg');
        $('.intl-tel-input').addClass('form-control');
        $('.intl-tel-input').addClass('border');
        $('.intl-tel-input').addClass('border-primary');
        $('.intl-tel-input').css('padding', 0);
        $('.intl-tel-input .form-control').css('border', 0);
      }
    },
    unsubscribe: function unsubscribe() {
      if (this.loggedUser && this.loggedUser.has_active_subscription && this.paymentMethod != 'payguru') {
        if (confirm(this.$root.trans('st_public.are you sure you\'d like to unsubscribe?'))) {
          this.callUnsubscribe();
        }
      } else if (this.loggedUser && !this.loggedUser.has_active_subscription) {
        flash(this.$root.trans('st_public.there is no active subscription'), 'error');
      } else {
        this.$router.push({ name: 'lang-login', params: { lang: this.lang } });
      }
    },
    callUnsubscribe: function callUnsubscribe() {
      var _this3 = this;

      this.loading = true;
      axios.delete(global.websiteSettings.extra_info.api_endpoint + 'api/unsubscribe').then(function (res) {
        _this3.loading = false;
        if (res.data.success) {
          flash(_this3.$root.trans('st_public.' + res.data.message), 'success');
        } else {
          flash(_this3.$root.trans('st_public.' + res.data.message), 'error');
        }
        _this3.refreshLoggedUser();
      }).catch(function (err) {
        _this3.loading = false;
        if (err.message) {
          flash(_this3.$root.trans('st_public.' + err.response.data.message), 'error');
        }
      });
    },
    refreshLoggedUser: function refreshLoggedUser() {
      this.$auth.getUser(function (user) {
        this.loggedUser = user;
      }.bind(this));
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/contact.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/contact.vue
// module chunks = 13